/* eslint-disable prefer-promise-reject-errors */
import queryString from 'query-string';
import { UserManager } from 'oidc-client';
import { oidcFetch, withOidcLogin } from './oidc';
import { saveLastPath, lastLang } from '../utils';

export const userContext = {};

export const createUserManager = ({
  userManagerConfig = {},
  apiHost,
  staticFilesHost,
  userRole,
}) => {
  const userManager = new UserManager(userManagerConfig);

  const privateFetch = (url, options) => oidcFetch(userManager, window.fetch, url, options);

  const withLogin = withOidcLogin(userManager, saveLastPath, (user) => {
    if (
      user &&
      userRole &&
      user.profile.role.toLowerCase().trim() !== userRole.toLowerCase().trim()
    ) {
      // fix infinite loop
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = userManagerConfig.authority;
      return false;
    }
    return true;
  });

  function apiCall({
    url,
    method,
    body,
    qs,
    qsOptions,
    isPublic,
    file,
    noResBody,
    headers,
    handleResponse,
  }) {
    return new Promise((resolve, reject) => {
      let newHeaders = {
        // in fetch contentType multipart/form-data must be "undefined"
        'Accept-Language': lastLang.current,
      };
      if (!file) newHeaders['Content-Type'] = 'application/json;charset=utf-8';
      newHeaders = { ...newHeaders, ...headers };

      const fetchToUse = isPublic ? window.fetch : privateFetch;

      fetchToUse(`${apiHost}${url}${qs ? `?${queryString.stringify(qs, qsOptions)}` : ''}`, {
        mode: 'cors',
        body: body ? JSON.stringify(body) : file || undefined,
        method: method || 'GET',
        headers: newHeaders,
      })
        .then((res) => {
          if (handleResponse) {
            handleResponse(res);
          } else if (res.status >= 200 && res.status < 300) {
            if (file || noResBody || res.status === 204) resolve(true);
            else res.json().then((json) => resolve(json));
          } else {
            res
              .json()
              .then((json) => reject({ status: res.status, ...json }))
              .catch(() => reject({ status: res.status, message: `Server Error ${res.status}!` }));
          }
        })
        .catch(() =>
          reject({
            message: 'There was a problem contacting our servers. Try refreshing the page!',
          })
        );
    });
  }

  async function staticFilesCall({ url, method, body, qs, qsOptions }) {
    const headers = {
      // in fetch contentType multipart/form-data must be "undefined"
      'Accept-Language': lastLang.current,
      'Content-Type': 'application/json;charset=utf-8',
    };

    try {
      const res = await window.fetch(
        `${staticFilesHost}${url}${qs ? `?${queryString.stringify(qs, qsOptions)}` : ''}`,
        {
          body: body ?? JSON.stringify(body),
          method: method ?? 'GET',
          headers,
        }
      );

      if (res.status >= 200 && res.status < 300) {
        try {
          return res.json();
        } catch (error) {
          return error;
        }
      } else {
        const json = await res.json();
        const obj = {
          status: res.status,
          ...json,
        };
        return obj;
      }
    } catch (error) {
      return new Error('There was a problem contacting our servers. Try refreshing the page!');
    }
  }

  userContext.userManager = userManager;
  userContext.withLogin = withLogin;
  userContext.apiCall = apiCall;
  userContext.staticFilesCall = staticFilesCall;

  return {
    userManager,
    withLogin,
    apiCall,
    staticFilesCall,
  };
};
